<template>
	<section class='knd-header'>
		<div class='knd-video gradient-overlay mobile-gradient-overlay'>
			<video playsinline loop muted autoplay>
				<source :src='getVideo()' type="video/mp4" />
				Uw browser ondersteunt het element <code>video</code> niet.
			</video>
		</div>		

		<div class='knd-intro'>
			<div class='knd-intro__inner'>
				<h1 class='knd-intro__title'>
					Bepaalt waar je <span class="knd-title__highlight">wieg</span> staat je <span class="knd-title__highlight">gezondheid</span>?
				</h1>

				<p class='knd-intro__lead' v-html="header.intro">
				</p>
				<div class='m-t-lg'>
					<Pijl kleur="#07034A" width="20" />
				</div>
			</div>
		</div>

	</section>
</template>

<script>
	import Pijl from '@/components/pijl';

	export default {
		name: 'Articles',
		components: {Pijl},
		computed: {
			articles () {
				return this.$store.state.articles;
			}
		},
		data: function() {
			return {
				header: this.$store.state.data
			}
		},
		methods: {
			getVideo() {
				let w = window.innerWidth;
				if(w < 560) {
					return require('@/assets/video/Intro_Chris_mobiel.mp4');
				} else {
					return require('@/assets/video/Intro_Chris_desktop.mp4');
				}
			}

		}
	}
</script>